import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/img/icons/ava.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-61834014"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav flex items-center justify-between py-3 px-6 border-b" }
const _hoisted_2 = { class: "flex w-full items-center justify-between" }
const _hoisted_3 = { class: "items-center hidden md:flex" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-200 rounded-full mr-3 p-3" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_5 = { class: "mr-4 text-sm leading-6 font-semibold tracking-wider text-blue-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BDropdownItem = _resolveComponent("BDropdownItem")!
  const _component_BDropdown = _resolveComponent("BDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
      }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.profileData.name || _ctx.profileData.email), 1)
        ]),
        _createVNode(_component_BDropdown, null, {
          default: _withCtx(() => [
            _createVNode(_component_BDropdownItem, { onClick: _ctx.logout }, {
              default: _withCtx(() => [
                _createTextVNode("Logout")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_BDropdown, { class: "flex md:hidden" }, {
        default: _withCtx(() => [
          _createVNode(_component_BDropdownItem, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.profileData.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_BDropdownItem, { onClick: _ctx.logout }, {
            default: _withCtx(() => [
              _createTextVNode("Logout")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ])
  ]))
}